export const setColor = (status: string): string => {
  switch (status) {
    case 'error': {
      return 'color-error'
    }
    case 'warning': {
      return 'color-warning'
    }
    case 'pending': {
      return 'color-pending'
    }
    case 'success': {
      return 'color-success'
    }
    default: {
      return ''
    }
  }
}
